import { Card, CardContent } from "../components/ui/Card.js";
import { Button } from "../components/ui/Button.js";
import { motion } from "framer-motion";
import { AlertCircle, ArrowLeft, Home } from "lucide-react";
import logo from "../assets/stock_images/logo.png";

export default function NotFound() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-background overflow-hidden relative">
      {/* Animated Background Blobs */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
        <motion.div
          animate={{
            x: [0, 50, 0],
            y: [0, 30, 0],
            scale: [1, 1.1, 1],
          }}
          transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
          className="absolute -top-[5%] -left-[5%] w-[40%] h-[40%] bg-primary/5 rounded-full blur-[100px]"
        />
        <motion.div
          animate={{
            x: [0, -40, 0],
            y: [0, 60, 0],
            scale: [1, 1.2, 1],
          }}
          transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
          className="absolute -bottom-[5%] -right-[5%] w-[35%] h-[35%] bg-accent/10 rounded-full blur-[100px]"
        />
      </div>

      <motion.div 
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="relative z-10 w-full max-w-lg mx-4"
      >
        <Card className="border-border/50 shadow-soft bg-card/50 backdrop-blur-xl overflow-hidden rounded-[2.5rem]">
          <CardContent className="p-10 text-center">
            <div className="flex flex-col items-center justify-center gap-6">
              <div className="relative">
                <motion.div 
                  initial={{ rotate: -10 }}
                  animate={{ rotate: 10 }}
                  transition={{ duration: 2, repeat: Infinity, repeatType: "reverse", ease: "easeInOut" }}
                  className="w-24 h-24 bg-white rounded-3xl shadow-soft flex items-center justify-center border border-border/20"
                >
                  <img src={logo} alt="Quro Logo" className="w-16 h-16" />
                </motion.div>
                <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-destructive flex items-center justify-center shadow-glow shadow-destructive/20 border-2 border-white">
                  <AlertCircle className="w-5 h-5 text-white" />
                </div>
              </div>
              
              <div className="space-y-3">
                <h1 className="font-display text-5xl font-bold tracking-tighter">404</h1>
                <h2 className="text-2xl font-bold text-foreground">Lost in the Neighborhood?</h2>
                <p className="text-muted-foreground leading-relaxed max-w-xs mx-auto">
                   Looks like the shop you're looking for has moved or doesn't exist. Let's get you back on track.
                </p>
              </div>

              <div className="flex gap-4 w-full pt-4">
                <Button 
                  onClick={() => window.location.href = "/"}
                  className="flex-1 h-14 rounded-2xl text-lg font-bold shadow-glow shadow-primary/20 hover:-translate-y-1 transition-all"
                >
                  <Home className="w-5 h-5 mr-2" />
                  Go Home
                </Button>
                <Button 
                  variant="outline"
                  onClick={() => window.history.back()}
                  className="flex-1 h-14 rounded-2xl font-bold border-border/50 hover:bg-muted/50 transition-all"
                >
                  <ArrowLeft className="w-5 h-5 mr-2" />
                  Go Back
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
}
